import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const ClientsPage = lazy(() => import('./ClientsPage'));
const ClientProfilePage = lazy(() => import('./ClientProfilePage'));

export const clientsRoutes: AppRoute[] = [
  { path: '/clientes', name: 'Clientas', element: ClientsPage },
  { path: '/clientes/:clientId', name: 'Ficha de clienta', element: ClientProfilePage },
];
